import app from '../app';

const { $body } = app.el;

$body.on('click', '.btn-toggle', function () {
  const $btn = $(this);
  $btn.toggleClass('btn-toggle--off btn-toggle--on').addClass('pe-none');
  setTimeout(() => $btn.removeClass('pe-none'), 500);
  const { btnToggleTips } = $btn.data();
  if (!btnToggleTips) return;
  if ($btn.hasClass('btn-toggle--on')) {
    app.comp.toast.success(btnToggleTips.on);
  } else {
    app.comp.toast.show(btnToggleTips.off);
  }
});

$body.on('click', '[data-click-to]', function () {
  $(this.dataset.clickTo).trigger('click', this);
  this.focus();
});
